import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";
import { ITwoFAPayload } from "../Declarations";

export const useSecretKey = (payload: ITwoFAPayload) =>
    useQuery<string>({
        enabled: Object.values(payload).every((v) => v !== ""),
        queryFn: async (): Promise<string> => {
            const axiosAuth = createAxiosClient("Auth");

            const response = await axiosAuth.post<string>(
                "/UILogin/SecretKey",
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        },
        queryKey: ["secretKey", payload.UserID],
    });
